import { render, staticRenderFns } from "./MethodsOfDelivery.vue?vue&type=template&id=5e444d2e"
import script from "./MethodsOfDelivery.vue?vue&type=script&lang=ts"
export * from "./MethodsOfDelivery.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports